import { createApi } from '@reduxjs/toolkit/query/react';

import { Opportunity, SRMStatus } from '@scaleup/models';
import { baseQuery } from './baseQuery';
import { TagTypes } from './tagTypes';

export const opportunityApi = createApi({
  reducerPath: 'opportunityApi',
  baseQuery: baseQuery,
  tagTypes: [TagTypes.opportunities, TagTypes.opportunity],
  endpoints: (builder) => ({
    getOpportunities: builder.query<Opportunity[], void>({
      query: () => `/opportunity`,
      providesTags: [TagTypes.opportunity],
    }),

    getOpportunity: builder.query<Opportunity, string>({
      query: (id) => `/opportunity/${id}`,
      providesTags: (_result, _error, id) => [
        { type: TagTypes.opportunity, id },
      ],
    }),

    answerOpportunityQuestions: builder.mutation<
      void,
      {
        id: string;
        answers: { [questionId: string]: string };
      }
    >({
      query: ({ id, answers }) => ({
        url: `/opportunity/${id}/questions`,
        method: 'PUT',
        body: answers,
      }),
    }),

    updateOpportunityStatus: builder.mutation<
      void,
      { status: SRMStatus; id: string }
    >({
      query: ({ status, id }) => ({
        url: `/opportunity/${id}/status`,
        method: 'PUT',
        body: { status },
      }),
    }),
  }),
});

export const {
  useGetOpportunitiesQuery,
  useGetOpportunityQuery,
  useAnswerOpportunityQuestionsMutation,
  useUpdateOpportunityStatusMutation,
} = opportunityApi;
